import React from 'react';
import PostNL from './AutofillAdressSources/PostNL';
import Form from './../../Form/Form';
import Icon from '../../Common/Icon';
import FieldWrapper from './../Common/FieldWrapper';

export default class PostcodeWithAutofill extends FieldWrapper {
  autofillCache = [];

  scheduleAutofill = () => {
    if (this.autofillTimeout) {
      clearTimeout(this.autofillTimeout);
    }
    this.autofillTimeout = setTimeout(this.autofill, 200);
  };

  setReadOnlyFields = readOnly => {
    const { config, form, formikForm } = this.props;
    let { streetName, cityName } = config;
    streetName = Form.encodeDots(streetName);
    cityName = Form.encodeDots(cityName);

    const fieldConfigs = Form.flattenFields(form.props.config.steps[0], false);
    const streetFieldConfig = fieldConfigs.find(({ name }) => name === streetName);
    streetFieldConfig.readOnly = readOnly;
    formikForm.setFieldTouched(streetName, false);

    const cityConfig = fieldConfigs.find(({ name }) => name === cityName);
    cityConfig.readOnly = readOnly;
    formikForm.setFieldTouched(cityName, false);
  };

  emptyFields = () => {
    const { config, formikForm } = this.props;
    let { streetName, cityName } = config;
    streetName = Form.encodeDots(streetName);
    cityName = Form.encodeDots(cityName);

    formikForm.setFieldValue(streetName, '', false);
    formikForm.setFieldTouched(streetName, false);
    formikForm.setFieldValue(cityName, '', false);
    formikForm.setFieldTouched(cityName, false);
  };

  componentDidMount() {
    this.update();
  }

  update() {
    const { config, formikForm, formikField } = this.props;
    const { source, readOnly, disabled  } = config;
    if(!source || readOnly || disabled) return;

    const { housenumberName, housenumberAdditionName } = source;
    const { requiredCountryName, requiredCountryValue } = source;
    if (!requiredCountryName) return;

    const country = formikForm.values[Form.encodeDots(requiredCountryName)];
    const postcode = formikField.value;
    const housenumber = housenumberName ? formikForm.values[Form.encodeDots(housenumberName)] : undefined;
    const housenumberAddition = housenumberAdditionName ? formikForm.values[Form.encodeDots(housenumberAdditionName)] : undefined;

    const valuesDidNotChange = (country === this.prevCountry && postcode === this.prevPostcode && housenumber === this.prevHousenumber && housenumberAddition === this.prevHousenumberAddition)
    if(valuesDidNotChange) return;

    this.prevCountry = country;
    this.prevPostcode = postcode;
    this.prevHousenumber = housenumber;
    this.prevHousenumberAddition = housenumberAddition;

    if (country === requiredCountryValue) {
      this.setReadOnlyFields(true);
      this.emptyFields();
      this.scheduleAutofill();
    } else {
      this.setReadOnlyFields(false);
      this.removeError();
    }
  }

  removeError() {
    if (this.state.autofillError) {
      this.setState({
        autofillError: undefined
      });
    }
  }

  autofillTimeout = undefined;
  autofill = async () => {
    this.removeError();

    const { config, formikForm } = this.props;
    let { name, source, streetName, cityName } = config;
    streetName = Form.encodeDots(streetName);
    cityName = Form.encodeDots(cityName);

    if (!source) {
      return;
    }
    if (!streetName || !cityName) {
      console.error('Cannot autofill based on the postcode because the fields config properties field.source, field.streetName and/or field.cityName are empty');
      return;
    }

    let value = formikForm.values[name] || '';
    if(value !== value.toUpperCase()) {
      formikForm.setFieldValue(name, value.toUpperCase(), true);
      return;
    }
    const postcode = value.toUpperCase();
    let hasError = !!formikForm.errors[name];

    let autofill = {
      street: undefined,
      city: undefined
    };

    if (source.type === 'postnl-national') {
      let { requiredCountryName, requiredCountryValue } = source;
      requiredCountryName = Form.encodeDots(requiredCountryName);
      if (requiredCountryName && formikForm.values[requiredCountryName] !== requiredCountryValue) {
        return;
      }

      if (!source.housenumberName && !source.housenumberAdditionName) {
        console.error('Cannot autofill based on the postcode because the fields config.source.housenumberName and/or config.source.housenumberAdditionName properties are empty');
        return;
      }

      const housenumberName = Form.encodeDots(source.housenumberName);
      const housenumber = formikForm.values[housenumberName];
      const housenumberAdditionName = Form.encodeDots(source.housenumberAdditionName);
      const housenumberAddition = formikForm.values[housenumberAdditionName];

      hasError = hasError || !!formikForm.errors[housenumberName] || !!formikForm.errors[housenumberAdditionName];

      if (!postcode || !housenumber || hasError) {
        this.emptyFields();
        return;
      }

      this.setReadOnlyFields(true);

      const cacheKey = `${postcode}_${housenumber}_${housenumberAddition}`;
      if (this.autofillCache[cacheKey]) {
        autofill = this.autofillCache[cacheKey];
      } else {
        try {
          autofill = await PostNL.autofill(source.url, postcode, housenumber, housenumberAddition);
          this.autofillCache[cacheKey] = autofill;
        } catch (error) {
          this.setState({
            autofillError: error
          });
          return;
        }
      }
    } else {
      console.error('Cannot autofill based on the postcode because the fields config property field.source.type property is empty or invalid');
      return;
    }

    if(autofill.street === '' && autofill.city === '') {
      this.setReadOnlyFields(false);
      return;
      //If you dont want to allow unknown postcalcodes
      //   this.setState({
      //     autofillError: new Error('UNKNOWN')
      //   });
    }

    if (autofill.street !== undefined) {
      formikForm.setFieldValue(streetName, autofill.street, !!autofill.street);
    }
    if (autofill.city !== undefined) {
      formikForm.setFieldValue(cityName, autofill.city, !!autofill.city);
    }
  };

  onFocus = () => {
    this.setState({
      focused: true
    });
  };
  onBlur = e => {
    this.setState({
      focused: false
    });
    if (e) this.props.formikField.onBlur(e);
  };

  renderField() {
    this.update();

    const { formikField, isRequired, config = {} } = this.props;
    const { name, placeholder, readOnly, disabled, label, labelInInput, labelHidden, icon, autofillErrorMessageText = '', autofillUnknownText = '', autofillRetryText = 'Retry' } = config;
    const { autofillError } = this.state;

    return (
      <React.Fragment>
        <div className="field__input-container">
          {!icon ? null : <Icon className="field__icon" iconName={icon} title={label} />}
          {!icon && !labelInInput ? null : (
            <label className={`field__input-label ${labelHidden ? 'sr-only' : ''}`} htmlFor={name}>
              {label}
            </label>
          )}
          <input
            id={name}
            className="field__input field__input--text"
            type="text"
            placeholder={placeholder}
            readOnly={!!readOnly}
            disabled={!!disabled}
            aria-required={!!isRequired}
            {...formikField}
            onFocus={this.onFocus}
            onBlur={e => {
              this.onBlur(e);
              if (autofillError) return;
              this.autofill();
            }}
            maxLength={6}
          />
        </div>
        {!autofillError ? null : (
          <div className="form__error">
            {autofillError.message === 'UNKNOWN' ? (
              autofillUnknownText
            ) : (
              <React.Fragment>
                {autofillErrorMessageText}
                {autofillError.message ? (
                  <React.Fragment>
                    <br />
                    {autofillError.message}
                  </React.Fragment>
                ) : (
                  ''
                )}
              </React.Fragment>
            )}
            <button onClick={this.autofill}>{autofillRetryText}</button>
          </div>
        )}
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/FormTemplates/Field/PostcodeWithAutofill.js